import script from "./RicetteTable4.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable4.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable4.vue?vue&type=style&index=0&id=02aebaf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02aebaf0"]])

export default __exports__